import { all, takeEvery, put, call, fork } from 'redux-saga/effects'
import { normalize } from 'normalizr'
import { apiFetch } from '../../../helpers/restRequest'
import actions from './actions'
import { itemTruckImagesSchema } from '../../schema'
import { deserialize } from '../../../helpers/jsonApi'

const {
    CUSTOMER_TRUCK_IMAGES_FETCH_REQUEST,
    CUSTOMER_TRUCK_IMAGES_FETCH,
    CUSTOMER_TRUCK_IMAGES_FETCH_SUCCESS,
    CUSTOMER_TRUCK_IMAGES_SET_PAGINATION,
} = actions

export function *fetchCustomerTruckImages () {
    yield takeEvery(CUSTOMER_TRUCK_IMAGES_FETCH_REQUEST, function *({ payload }) {
        yield put({ type: CUSTOMER_TRUCK_IMAGES_FETCH })

        const { customerId, page, per } = payload

        const queryString = `page=${page}&per=${per}`

        const path = `/customers/${customerId}/item_truck_images?${queryString}`
        const data = yield call(apiFetch, path)
        const formattedData = deserialize(data)
        const normalizeData = normalize(formattedData, itemTruckImagesSchema)
        const total = data.meta ? data.meta.total_pages * per : null

        yield put({
            type: CUSTOMER_TRUCK_IMAGES_SET_PAGINATION,
            pagination: { current: page, pageSize: per, total }
        })

        yield put({
            type: CUSTOMER_TRUCK_IMAGES_FETCH_SUCCESS,
            ...normalizeData
        })
    })
}

export default function *rootSaga () {
    yield all([
        fork(fetchCustomerTruckImages),
    ])
}
